import * as React from "react";
import { Form, useFormApi, useFormState } from "informedv4";
import { TextBox } from "../../forms/informedv4/TextBoxV4";
import { Link } from "react-router-dom";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import { RequiredNotBlank } from "../../forms/validation/Required";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useWebPortalApiClient, useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";

export const CreateRole = () => {
    return (
        <Form validateOn="submit">
            <CreateRoleForm />
        </Form>
    );
}

export interface CreateRoleFormModel {
    name: string;
}

const CreateRoleForm = () => {
    const client = useWebPortalApiClient();
    const legacyClient = useWebPortalLegacyClient();
    const formApi = useFormApi();
    const formState = useFormState();
    const [selectedFile, setSelectedFile] = React.useState<File>();
    const [errorAlert, setErrorAlert] = React.useState<string>();
    const [successAlert, setSuccessAlert] = React.useState(false);
    const { study } = useCurrentStudyConfigurationContext();

    


    const onSaveClick = async () => {
        setSuccessAlert(undefined);
        setErrorAlert(undefined);
        formApi.validate();
        const state = formApi.getFormState();

        if (state.invalid) {
            setSuccessAlert(false);
            return setErrorAlert("Errors exist on the page");
        }

        try {
            if (selectedFile !== undefined && selectedFile?.type !== "application/json") {
                return setErrorAlert("Invalid input permissions file. It must be a valid JSON file which was created by the Role Permissions Export function.");
            }

            const role = await client.client.postRole({
                name: state.values.name as string,
                studyId: study.id
            });

            if (selectedFile !== undefined) {
                await legacyClient.importPermissionsApi(role.id, selectedFile);
            }

            setSuccessAlert(true);
        } catch (ex) {
            if (ex.message || ex.Message) {
                return setErrorAlert(ex.message ?? ex.Message);
            }
        }
    }

    return (
        <>
            <Alert show={successAlert} category={AlertCategoryEnum.Success}>
                Saved successfully. Return to{" "}
                <Link to={`/rolemanagement`}>Role Management</Link>?
            </Alert>
            <Alert show={errorAlert !== undefined} category={AlertCategoryEnum.Danger}>
                {errorAlert}
            </Alert>
            <div className="row">
                <div className="col-md-6">
                    <h2 className="text-primary">Create Role</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div id="createRolePanel" className="panel panel-primary">
                        <div className="panel-body">
                            <div className="row">
                                <div className="form-group col-sm-6 col-xs-12">
                                    <label htmlFor="name">Name</label>
                                    <TextBox name="name" id="name" field="name" validate={RequiredNotBlank} required={true} />
                                </div>
                                <div className="form-group col-sm-6 col-xs-12">
                                    <label>Import Permissions</label>
                                    <input type="file" className="form-control" accept="application/json" onChange={(e) => setSelectedFile(e.target.files[0])} />
                                    <span className="help-text">Optional. Choose file if importing from a previously exported role.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="h2 pull-right">
                        <button id="saveButton" className="btn btn-primary" type="button" disabled={false} onClick={onSaveClick}>
                            Save
                        </button>&nbsp;
                        <Link id="returnToListButton" className="btn btn-primary btn-outline" to="/rolemanagement">
                            Return to List
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
}
